import React from 'react';
import PropTypes from 'prop-types';

const NotificationIcon = ({ style, fill }) => (
  <svg
    width="46"
    height="46"
    style={{ ...style }}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.88">
      {/* Bell */}
      <path
        d="M23 6C19.6863 6 17 8.68629 17 12V22L14 25V26H32V25L29 22V12C29 8.68629 26.3137 6 23 6Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Clapper */}
      <path
        d="M23 32C21.3431 32 20 30.6569 20 29H26C26 30.6569 24.6569 32 23 32Z"
        fill={fill}
      />
      {/* Optional notification dot */}
      <circle cx="32" cy="10" r="5" fill="#FF3B30" />
    </g>
  </svg>
);

NotificationIcon.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.any,
};

NotificationIcon.defaultProps = {
  fill: '#575757',
  style: {},
};

export default NotificationIcon;
